import { fetchAuthSession } from 'aws-amplify/auth';

import config from 'aws-exports';

/**
 * A 30-day pay-without-signing-in link for a policy (#36685), from core-resources'
 * /guest-payment/share-link. The staff ID token carries the groups and agency claims the route checks.
 */
export async function createGuestPaymentLink(policyId) {
  const session = await fetchAuthSession();
  const response = await fetch(`${config.coreResourcesEndpoint}/guest-payment/share-link`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Api-Key': config.coreResourcesApiKey,
      Authorization: `Bearer ${session.tokens?.idToken?.toString()}`
    },
    body: JSON.stringify({ policyId })
  });
  const body = await response.json().catch(() => null);
  if (!response.ok) {
    throw new Error(body?.message || `${response.status} ${response.statusText}`);
  }
  return body;
}
